// utils
import { generateRandomCode } from 'app/utils';

function formatFurnitureCallback(furnitureReportProblem) {
  const { furnitureId, problemClassification, quantity, description, formAddOn } =
    furnitureReportProblem;

  const randomCode = formAddOn.randomCode ? formAddOn.randomCode : generateRandomCode();
  return {
    furnitureId,
    problemClassification,
    quantity,
    description,
    formAddOn: {
      ...formAddOn,
      hasError: false,
      randomCode
    }
  };
}

export { formatFurnitureCallback };
